import { QuestionKey, } from "@gigsync/protocol";
/**
 * What the agent remembers from past jobs, so the next time it talks for its owner it need not ask again. It lives
 * only on this phone, one document per owner, is listed and forgettable in Profile, and stays when the owner signs out:
 * hidden while they are away, theirs again when they sign back in (owner/storage.ts).
 *
 * Never kept: the other side's phone or address (their name only), payment references, and anything from a job that
 * both sides did not sign, except the owner's own facts.
 */
const Q = QuestionKey.enum;
/** Details about a home that stay true from one job to the next, so a remembered value can answer them again. */
export const STABLE_FACTS = new Set([
    Q.rooms,
    Q.pets,
    Q.people,
    Q.meals,
    Q.area_sqft,
    Q.route,
]);
/** One line of the Profile list; `key` is what `forgetMemory` takes. */
export const MemoryItemKind = {
    fact: "fact",
    area: "area",
    person: "person",
    asked: "asked",
};
/** `forgetMemory(owner, FORGET_ALL)` clears everything this owner's agent remembers. */
export const FORGET_ALL = "all";
//# sourceMappingURL=types.js.map